import React from 'react';
import Chart from './Chart';
import { data } from '../../../dummyData/dummyData';
const UserAnalytics = () => {
	return (
		
		<Chart data={data}></Chart>
  

	);
};

export default UserAnalytics;